
export class PasModelFamiliesError extends Error {
	constructor(public errorCode: string, public errorMessage: string = '', public errorSeverity?: string, public appName?: string) {
		super(errorMessage);
		Object.setPrototypeOf(this, PasModelFamiliesError.prototype);
	}
}
